
import React, { useEffect, useState } from "react";
import { SubmitButton, required, FormGroup, DatePicker } from "components/common";
import { Control, actions, Errors } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import { useForm } from "hooks";
import Select from "react-select";
import { Trans } from "react-i18next";
import { useXeroClient } from "hooks";
import { Col, Row } from "reactstrap";

export const BillPayment = ({
    payroll,
    t,
    model = "local",
    amount,
    url,
    setReload
}) => {
    const { dispatch, setValue, Form, savePatch, save, load, value, watch } = useForm({ model });

    const xero = useXeroClient();

    const [account, setAccount] = useState([]);

    useEffect(() => {
        xero("accounts").then((data) => {
            setAccount(data["data"].filter((i) => i.Type == "BANK"));
        })
    }, []);

    async function onSubmit(item) {
        payroll.post(url, item).then((resp)=>{
            NotificationManager.success(t("Payment made successfully"));
            setReload((old)=>!old)
        }).catch((err)=>{
            NotificationManager.error(t("Couldn't make the payment"));
        }).
        finally(()=> {
            dispatch(actions.setPending(model, false));
        })
        return
    }

    return (
        <div className="d-inline-block my-2">
            <Form
                onSubmit={onSubmit}
                validators={{
                    Amount: { required },
                    Date: { required },
                    Date: { required },
                    "Account.AccountID": { required },
                }}
            >
                <Row>
                    <Col className="col-auto d-flex align-items-end">
                        <FormGroup
                            label="Amount To Pay"
                            model=".Amount"
                            style={{ width: "9rem" }}
                        >
                            <Control.text type="number" step="any" model=".Amount" defaultValue={amount} max={amount} />
                        </FormGroup>
                    </Col>
                    <Col className="col-auto d-flex align-items-end">
                        <FormGroup
                            label="Date Paid"
                            model=".Date"
                            style={{ width: "8rem" }}
                        >
                            <DatePicker type="date" model=".Date" className="form-control" defaultValue={new Date().toJSON().slice(0, 10)} />
                        </FormGroup>
                    </Col>
                    <Col className="col-auto d-flex align-items-end">
                        <FormGroup
                            label="Paid From"
                            model=".Account.AccountID"
                            addControlClass={false}
                        >
                            <Control.text
                                style={{ minWidth: "12rem" }}
                                simpleValue
                                labelKey="Name"
                                valueKey="AccountID"
                                component={Select}
                                model=".Account.AccountID"
                                options={account}
                            />
                        </FormGroup>
                    </Col>
                    <Col className="col-auto d-flex align-items-end">
                        <FormGroup label="Reference" model=".Reference">
                            <Control.text model=".Reference" />
                        </FormGroup>
                    </Col>
                    <div className="col-auto d-flex align-items-end">
                        <FormGroup>
                            <SubmitButton>Make Payment</SubmitButton>
                        </FormGroup > 
                    </div>
                </Row>
            </Form>
        </div>
    )
}
